

import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { FreeShipMethodID, DefaultShipMethodID, FlatRateShipMethodID, DefaultCountry } from 'src/app/constant';
import { ConfigService } from './config.service';

@Injectable({
    providedIn: 'root'
})
export class ShippingMethodService {

    constructor(public configService: ConfigService) {}

    getShippingMethodId(orderSubtotal: number, customerType: number, isAutoShip: boolean): string {
        const selectedCountry = this.configService.commonData.selectedCountry || DefaultCountry;
        const shippingData = this.configService.commonData?.CountryCode?.[selectedCountry];
        const shippingMethodId = shippingData?.ShippingMethod || DefaultShipMethodID;
        const today = new Date();
        const dayOfMonth = today.getDate();

        if (customerType === 1 || customerType === 2 || customerType === 3) {
            if ((isAutoShip && dayOfMonth >= 1 && dayOfMonth <= 5) && customerType !== 3) {
                return FreeShipMethodID;
            }
            if(isAutoShip && (customerType === 3 || customerType === 2)){
                return FreeShipMethodID;
            }
            if (orderSubtotal >= 145) {
                return FreeShipMethodID;
            }
        }
        return shippingMethodId;
    }
}